/**
 * vietnam-city.js
 * Thư viện dựng cảnh quan Đô Thị Việt Nam chuẩn Voxel Art.
 * Cấu trúc module phân tách kết hợp qua Registry/Mixin.
 */

import { registerCoreMethods, createRng, hashString, shade } from './builder-core.js';
import { registerTextureMethods } from './textures/city-textures.js';
import { registerHousePartsMethods } from './buildings/house-parts.js';
import { registerTubeHouseMethods } from './buildings/tube-houses.js';
import { registerStreetMethods } from './street/street.js';
import { registerVehicleMethods } from './vehicles/vehicles.js';
import { registerVegetationMethods } from './vegetation/trees.js';

export { createRng, hashString, shade };

export class VietnamCityBuilder {
  constructor() {
    this.disposables = [];
    this._matCache = new Map();
    this._geoCache = new Map();
    this._texCache = new Map();
  }

  dispose() {
    this.disposables.forEach((item) => {
      if (item && typeof item.dispose === 'function') {
        item.dispose();
      }
    });
    this.disposables = [];
    this._matCache.clear();
    this._geoCache.clear();
    this._texCache.clear();
  }
}

// Đăng ký toàn bộ phương thức từ các submodules vào prototype của VietnamCityBuilder
registerCoreMethods(VietnamCityBuilder.prototype);
registerTextureMethods(VietnamCityBuilder.prototype);
registerHousePartsMethods(VietnamCityBuilder.prototype);
registerTubeHouseMethods(VietnamCityBuilder.prototype);
registerStreetMethods(VietnamCityBuilder.prototype);
registerVehicleMethods(VietnamCityBuilder.prototype);
registerVegetationMethods(VietnamCityBuilder.prototype);
